import {
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Divider,
 
} from '@mui/material'
import StoreIcon from '@mui/icons-material/Store';


const ShopAdressCard = ({current}) => {


    const listStyles = {
        color: '#000',
        fontSize: '24px',
        fontFamily: 'sans-serif',
 
        padding: '0px',
       margin: '0px'
      }
   


    return(
        <>
        <hr/>
            <List className='adressInfocard'>

          
                

                
                <div>   

                { current.adressList.length>>0 ?
                    <div className='mt-3 content'>

                { current.adressList.map(item=>(
                       
                   
                                            
                           <div>
              <Divider variant='inset' component="li"/>
              <ListItem>
                    
                    <ListItemAvatar>
                        <Avatar><StoreIcon/></Avatar>
                        </ListItemAvatar>
                        <ListItemText style={listStyles} primary="Adress" />
                
                    
                  </ListItem>
                 <ListItem>
                    
                    <ListItemText style={listStyles}  primary={item.line1} />
                    
                    
                </ListItem>

                <ListItem>
                    
                   <ListItemText style={listStyles}   primary={item.line2} />
                    
                </ListItem>
               
                <ListItem>
                <ListItemText style={listStyles}   primary={item.area} />
                </ListItem>
                <ListItem>
                    <ListItemText style={listStyles}   primary={item.area2} />
                </ListItem>

                <ListItem>
                <ListItemText style={listStyles} primary="DISTRICT" secondary='KOLAR'/>
                <ListItemText style={listStyles} primary="TALUK" secondary='MALUR'/>
                <ListItemText style={listStyles} primary="PIN CODE : " secondary= {item.pincode} />
                </ListItem>
               

                
                            </div>                 
                               
                     
                                        
                                            
                        ))}
                        
                        
                   
                        
                        
                        

                            
              
                
                    </div>
                    :null
}                      
</div> 

               
            </List>
           

        </>
    )
}

export default ShopAdressCard